var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316-232h53.333v-85.333h85.334v-53.333h-85.334V-456H316v85.334h-85.334v53.333H316V-232Zm210-33.333h200.667V-318H526v52.667ZM526-370h200.667v-53.333H526V-370Zm39.333-159.334 59.334-59.333L684-529.334l38-37.999-59.333-60L722-686.667l-38-38-59.333 59.334-59.334-59.334-38 38 59.334 59.334-59.334 60 38 37.999ZM244-600.667h197.333V-654H244v53.333ZM186.666-120q-27 0-46.833-19.833T120-186.666v-586.668q0-27 19.833-46.833T186.666-840h586.668q27 0 46.833 19.833T840-773.334v586.668q0 27-19.833 46.833T773.334-120H186.666Zm0-66.666h586.668v-586.668H186.666v586.668Zm0-586.668v586.668-586.668Z",
    fill: "#5D616D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentOutline);
export default __webpack_public_path__ + "static/media/Payment Outline.79c517bdd47abb6798063056ee76c512.svg";
export { ForwardRef as ReactComponent };